export const styles = {
  wrapper: {
    marginTop: 3,
    marginBottom: 3,
  },
};
